// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.10.1
//   protoc               v3.21.12
// source: getdashboardmetrics.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "login";

export interface GetDashboardMetricsRequest {
  /** YYYY-MM-DD format */
  startDate?:
    | string
    | undefined;
  /** YYYY-MM-DD format */
  endDate?:
    | string
    | undefined;
  /** If true, exclude internal provider data */
  hideInternal?: boolean | undefined;
}

export interface DailyMetric {
  /** YYYY-MM-DD */
  date: string;
  count: number;
}

export interface DistributionItem {
  label: string;
  count: number;
}

export interface LocationData {
  /** City/location name */
  name: string;
  latitude: number;
  longitude: number;
  caseCount: number;
  /** Country name for country-level aggregation */
  country: string;
}

export interface DailyCost {
  /** YYYY-MM-DD */
  date: string;
  /** OpenAI cost for this day in USD */
  openaiCost: number;
  /** GCP cost for this day in USD */
  gcpCost: number;
}

export interface GetDashboardMetricsResponse {
  totalSubmittedCases: number;
  uniqueProvidersSubmitted: number;
  avgCasesPerProvider: number;
  percentFailedCases: number;
  avgProcessingTimeSeconds: number;
  percentCasesWithSurvey: number;
  avgSurveyResponse: number;
  percentSurveysWithComment: number;
  casesPerDay: DailyMetric[];
  providerSignupsPerDay: DailyMetric[];
  totalNewSignups: number;
  percentRegistrationComplete: number;
  adjudicationSuccessRate: number;
  cancerTypeDistribution: DistributionItem[];
  referralTypeDistribution: DistributionItem[];
  modelAdjudicationDistribution: DistributionItem[];
  /** Total OpenAI API cost in USD for the date range */
  openaiApiCost: number;
  /** Total Google Cloud cost in USD for the date range */
  gcpCost: number;
  /** Case locations with lat/lng for map */
  caseLocations: LocationData[];
  /** Daily breakdown of API costs */
  apiCostsPerDay: DailyCost[];
  /** Previous period metrics (optional, populated if date range allows) */
  previousTotalSubmittedCases: number;
  totalSubmittedCasesGrowth: number;
  previousUniqueProvidersSubmitted: number;
  uniqueProvidersSubmittedGrowth: number;
  previousTotalNewSignups: number;
  totalNewSignupsGrowth: number;
  /** Percentage breakdowns */
  registrationsCompletedNumerator: number;
  registrationsCompletedDenominator: number;
  failedCasesNumerator: number;
  failedCasesDenominator: number;
  surveysCompletedNumerator: number;
  surveysCompletedDenominator: number;
  surveysWithCommentsNumerator: number;
  surveysWithCommentsDenominator: number;
  /** Additional previous period metrics for rate/avg metrics */
  previousPercentRegistrationComplete: number;
  percentRegistrationCompleteGrowth: number;
  previousPercentFailedCases: number;
  percentFailedCasesGrowth: number;
  previousAvgProcessingTimeSeconds: number;
  avgProcessingTimeSecondsGrowth: number;
  previousAvgSurveyScore: number;
  avgSurveyScoreGrowth: number;
  previousAvgCasesPerProvider: number;
  avgCasesPerProviderGrowth: number;
}

function createBaseGetDashboardMetricsRequest(): GetDashboardMetricsRequest {
  return { startDate: undefined, endDate: undefined, hideInternal: undefined };
}

export const GetDashboardMetricsRequest: MessageFns<GetDashboardMetricsRequest> = {
  encode(message: GetDashboardMetricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startDate !== undefined) {
      writer.uint32(10).string(message.startDate);
    }
    if (message.endDate !== undefined) {
      writer.uint32(18).string(message.endDate);
    }
    if (message.hideInternal !== undefined) {
      writer.uint32(24).bool(message.hideInternal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDashboardMetricsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDashboardMetricsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startDate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endDate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.hideInternal = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDashboardMetricsRequest {
    return {
      startDate: isSet(object.startDate) ? globalThis.String(object.startDate) : undefined,
      endDate: isSet(object.endDate) ? globalThis.String(object.endDate) : undefined,
      hideInternal: isSet(object.hideInternal) ? globalThis.Boolean(object.hideInternal) : undefined,
    };
  },

  toJSON(message: GetDashboardMetricsRequest): unknown {
    const obj: any = {};
    if (message.startDate !== undefined) {
      obj.startDate = message.startDate;
    }
    if (message.endDate !== undefined) {
      obj.endDate = message.endDate;
    }
    if (message.hideInternal !== undefined) {
      obj.hideInternal = message.hideInternal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDashboardMetricsRequest>, I>>(base?: I): GetDashboardMetricsRequest {
    return GetDashboardMetricsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDashboardMetricsRequest>, I>>(object: I): GetDashboardMetricsRequest {
    const message = createBaseGetDashboardMetricsRequest();
    message.startDate = object.startDate ?? undefined;
    message.endDate = object.endDate ?? undefined;
    message.hideInternal = object.hideInternal ?? undefined;
    return message;
  },
};

function createBaseDailyMetric(): DailyMetric {
  return { date: "", count: 0 };
}

export const DailyMetric: MessageFns<DailyMetric> = {
  encode(message: DailyMetric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.count !== 0) {
      writer.uint32(16).int64(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetric {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: DailyMetric): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetric>, I>>(base?: I): DailyMetric {
    return DailyMetric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetric>, I>>(object: I): DailyMetric {
    const message = createBaseDailyMetric();
    message.date = object.date ?? "";
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseDistributionItem(): DistributionItem {
  return { label: "", count: 0 };
}

export const DistributionItem: MessageFns<DistributionItem> = {
  encode(message: DistributionItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.count !== 0) {
      writer.uint32(16).int64(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DistributionItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDistributionItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DistributionItem {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: DistributionItem): unknown {
    const obj: any = {};
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DistributionItem>, I>>(base?: I): DistributionItem {
    return DistributionItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DistributionItem>, I>>(object: I): DistributionItem {
    const message = createBaseDistributionItem();
    message.label = object.label ?? "";
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseLocationData(): LocationData {
  return { name: "", latitude: 0, longitude: 0, caseCount: 0, country: "" };
}

export const LocationData: MessageFns<LocationData> = {
  encode(message: LocationData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.latitude !== 0) {
      writer.uint32(17).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(25).double(message.longitude);
    }
    if (message.caseCount !== 0) {
      writer.uint32(32).int64(message.caseCount);
    }
    if (message.country !== "") {
      writer.uint32(42).string(message.country);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocationData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocationData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.caseCount = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.country = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocationData {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      caseCount: isSet(object.caseCount) ? globalThis.Number(object.caseCount) : 0,
      country: isSet(object.country) ? globalThis.String(object.country) : "",
    };
  },

  toJSON(message: LocationData): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.caseCount !== 0) {
      obj.caseCount = Math.round(message.caseCount);
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationData>, I>>(base?: I): LocationData {
    return LocationData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationData>, I>>(object: I): LocationData {
    const message = createBaseLocationData();
    message.name = object.name ?? "";
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.caseCount = object.caseCount ?? 0;
    message.country = object.country ?? "";
    return message;
  },
};

function createBaseDailyCost(): DailyCost {
  return { date: "", openaiCost: 0, gcpCost: 0 };
}

export const DailyCost: MessageFns<DailyCost> = {
  encode(message: DailyCost, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.openaiCost !== 0) {
      writer.uint32(17).double(message.openaiCost);
    }
    if (message.gcpCost !== 0) {
      writer.uint32(25).double(message.gcpCost);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyCost {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyCost();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.openaiCost = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.gcpCost = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyCost {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      openaiCost: isSet(object.openaiCost) ? globalThis.Number(object.openaiCost) : 0,
      gcpCost: isSet(object.gcpCost) ? globalThis.Number(object.gcpCost) : 0,
    };
  },

  toJSON(message: DailyCost): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.openaiCost !== 0) {
      obj.openaiCost = message.openaiCost;
    }
    if (message.gcpCost !== 0) {
      obj.gcpCost = message.gcpCost;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyCost>, I>>(base?: I): DailyCost {
    return DailyCost.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyCost>, I>>(object: I): DailyCost {
    const message = createBaseDailyCost();
    message.date = object.date ?? "";
    message.openaiCost = object.openaiCost ?? 0;
    message.gcpCost = object.gcpCost ?? 0;
    return message;
  },
};

function createBaseGetDashboardMetricsResponse(): GetDashboardMetricsResponse {
  return {
    totalSubmittedCases: 0,
    uniqueProvidersSubmitted: 0,
    avgCasesPerProvider: 0,
    percentFailedCases: 0,
    avgProcessingTimeSeconds: 0,
    percentCasesWithSurvey: 0,
    avgSurveyResponse: 0,
    percentSurveysWithComment: 0,
    casesPerDay: [],
    providerSignupsPerDay: [],
    totalNewSignups: 0,
    percentRegistrationComplete: 0,
    adjudicationSuccessRate: 0,
    cancerTypeDistribution: [],
    referralTypeDistribution: [],
    modelAdjudicationDistribution: [],
    openaiApiCost: 0,
    gcpCost: 0,
    caseLocations: [],
    apiCostsPerDay: [],
    previousTotalSubmittedCases: 0,
    totalSubmittedCasesGrowth: 0,
    previousUniqueProvidersSubmitted: 0,
    uniqueProvidersSubmittedGrowth: 0,
    previousTotalNewSignups: 0,
    totalNewSignupsGrowth: 0,
    registrationsCompletedNumerator: 0,
    registrationsCompletedDenominator: 0,
    failedCasesNumerator: 0,
    failedCasesDenominator: 0,
    surveysCompletedNumerator: 0,
    surveysCompletedDenominator: 0,
    surveysWithCommentsNumerator: 0,
    surveysWithCommentsDenominator: 0,
    previousPercentRegistrationComplete: 0,
    percentRegistrationCompleteGrowth: 0,
    previousPercentFailedCases: 0,
    percentFailedCasesGrowth: 0,
    previousAvgProcessingTimeSeconds: 0,
    avgProcessingTimeSecondsGrowth: 0,
    previousAvgSurveyScore: 0,
    avgSurveyScoreGrowth: 0,
    previousAvgCasesPerProvider: 0,
    avgCasesPerProviderGrowth: 0,
  };
}

export const GetDashboardMetricsResponse: MessageFns<GetDashboardMetricsResponse> = {
  encode(message: GetDashboardMetricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalSubmittedCases !== 0) {
      writer.uint32(8).int64(message.totalSubmittedCases);
    }
    if (message.uniqueProvidersSubmitted !== 0) {
      writer.uint32(16).int64(message.uniqueProvidersSubmitted);
    }
    if (message.avgCasesPerProvider !== 0) {
      writer.uint32(25).double(message.avgCasesPerProvider);
    }
    if (message.percentFailedCases !== 0) {
      writer.uint32(33).double(message.percentFailedCases);
    }
    if (message.avgProcessingTimeSeconds !== 0) {
      writer.uint32(41).double(message.avgProcessingTimeSeconds);
    }
    if (message.percentCasesWithSurvey !== 0) {
      writer.uint32(49).double(message.percentCasesWithSurvey);
    }
    if (message.avgSurveyResponse !== 0) {
      writer.uint32(57).double(message.avgSurveyResponse);
    }
    if (message.percentSurveysWithComment !== 0) {
      writer.uint32(65).double(message.percentSurveysWithComment);
    }
    for (const v of message.casesPerDay) {
      DailyMetric.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.providerSignupsPerDay) {
      DailyMetric.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.totalNewSignups !== 0) {
      writer.uint32(88).int64(message.totalNewSignups);
    }
    if (message.percentRegistrationComplete !== 0) {
      writer.uint32(97).double(message.percentRegistrationComplete);
    }
    if (message.adjudicationSuccessRate !== 0) {
      writer.uint32(105).double(message.adjudicationSuccessRate);
    }
    for (const v of message.cancerTypeDistribution) {
      DistributionItem.encode(v!, writer.uint32(114).fork()).join();
    }
    for (const v of message.referralTypeDistribution) {
      DistributionItem.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.modelAdjudicationDistribution) {
      DistributionItem.encode(v!, writer.uint32(130).fork()).join();
    }
    if (message.openaiApiCost !== 0) {
      writer.uint32(137).double(message.openaiApiCost);
    }
    if (message.gcpCost !== 0) {
      writer.uint32(145).double(message.gcpCost);
    }
    for (const v of message.caseLocations) {
      LocationData.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.apiCostsPerDay) {
      DailyCost.encode(v!, writer.uint32(162).fork()).join();
    }
    if (message.previousTotalSubmittedCases !== 0) {
      writer.uint32(168).int64(message.previousTotalSubmittedCases);
    }
    if (message.totalSubmittedCasesGrowth !== 0) {
      writer.uint32(177).double(message.totalSubmittedCasesGrowth);
    }
    if (message.previousUniqueProvidersSubmitted !== 0) {
      writer.uint32(184).int64(message.previousUniqueProvidersSubmitted);
    }
    if (message.uniqueProvidersSubmittedGrowth !== 0) {
      writer.uint32(193).double(message.uniqueProvidersSubmittedGrowth);
    }
    if (message.previousTotalNewSignups !== 0) {
      writer.uint32(200).int64(message.previousTotalNewSignups);
    }
    if (message.totalNewSignupsGrowth !== 0) {
      writer.uint32(209).double(message.totalNewSignupsGrowth);
    }
    if (message.registrationsCompletedNumerator !== 0) {
      writer.uint32(216).int64(message.registrationsCompletedNumerator);
    }
    if (message.registrationsCompletedDenominator !== 0) {
      writer.uint32(224).int64(message.registrationsCompletedDenominator);
    }
    if (message.failedCasesNumerator !== 0) {
      writer.uint32(232).int64(message.failedCasesNumerator);
    }
    if (message.failedCasesDenominator !== 0) {
      writer.uint32(240).int64(message.failedCasesDenominator);
    }
    if (message.surveysCompletedNumerator !== 0) {
      writer.uint32(248).int64(message.surveysCompletedNumerator);
    }
    if (message.surveysCompletedDenominator !== 0) {
      writer.uint32(256).int64(message.surveysCompletedDenominator);
    }
    if (message.surveysWithCommentsNumerator !== 0) {
      writer.uint32(264).int64(message.surveysWithCommentsNumerator);
    }
    if (message.surveysWithCommentsDenominator !== 0) {
      writer.uint32(272).int64(message.surveysWithCommentsDenominator);
    }
    if (message.previousPercentRegistrationComplete !== 0) {
      writer.uint32(281).double(message.previousPercentRegistrationComplete);
    }
    if (message.percentRegistrationCompleteGrowth !== 0) {
      writer.uint32(289).double(message.percentRegistrationCompleteGrowth);
    }
    if (message.previousPercentFailedCases !== 0) {
      writer.uint32(297).double(message.previousPercentFailedCases);
    }
    if (message.percentFailedCasesGrowth !== 0) {
      writer.uint32(305).double(message.percentFailedCasesGrowth);
    }
    if (message.previousAvgProcessingTimeSeconds !== 0) {
      writer.uint32(313).double(message.previousAvgProcessingTimeSeconds);
    }
    if (message.avgProcessingTimeSecondsGrowth !== 0) {
      writer.uint32(321).double(message.avgProcessingTimeSecondsGrowth);
    }
    if (message.previousAvgSurveyScore !== 0) {
      writer.uint32(329).double(message.previousAvgSurveyScore);
    }
    if (message.avgSurveyScoreGrowth !== 0) {
      writer.uint32(337).double(message.avgSurveyScoreGrowth);
    }
    if (message.previousAvgCasesPerProvider !== 0) {
      writer.uint32(345).double(message.previousAvgCasesPerProvider);
    }
    if (message.avgCasesPerProviderGrowth !== 0) {
      writer.uint32(353).double(message.avgCasesPerProviderGrowth);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDashboardMetricsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDashboardMetricsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalSubmittedCases = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.uniqueProvidersSubmitted = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.avgCasesPerProvider = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.percentFailedCases = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.avgProcessingTimeSeconds = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.percentCasesWithSurvey = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.avgSurveyResponse = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.percentSurveysWithComment = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.casesPerDay.push(DailyMetric.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.providerSignupsPerDay.push(DailyMetric.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.totalNewSignups = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.percentRegistrationComplete = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.adjudicationSuccessRate = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.cancerTypeDistribution.push(DistributionItem.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.referralTypeDistribution.push(DistributionItem.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.modelAdjudicationDistribution.push(DistributionItem.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.openaiApiCost = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 145) {
            break;
          }

          message.gcpCost = reader.double();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.caseLocations.push(LocationData.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.apiCostsPerDay.push(DailyCost.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.previousTotalSubmittedCases = longToNumber(reader.int64());
          continue;
        }
        case 22: {
          if (tag !== 177) {
            break;
          }

          message.totalSubmittedCasesGrowth = reader.double();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.previousUniqueProvidersSubmitted = longToNumber(reader.int64());
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.uniqueProvidersSubmittedGrowth = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.previousTotalNewSignups = longToNumber(reader.int64());
          continue;
        }
        case 26: {
          if (tag !== 209) {
            break;
          }

          message.totalNewSignupsGrowth = reader.double();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.registrationsCompletedNumerator = longToNumber(reader.int64());
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.registrationsCompletedDenominator = longToNumber(reader.int64());
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.failedCasesNumerator = longToNumber(reader.int64());
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.failedCasesDenominator = longToNumber(reader.int64());
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.surveysCompletedNumerator = longToNumber(reader.int64());
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.surveysCompletedDenominator = longToNumber(reader.int64());
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.surveysWithCommentsNumerator = longToNumber(reader.int64());
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.surveysWithCommentsDenominator = longToNumber(reader.int64());
          continue;
        }
        case 35: {
          if (tag !== 281) {
            break;
          }

          message.previousPercentRegistrationComplete = reader.double();
          continue;
        }
        case 36: {
          if (tag !== 289) {
            break;
          }

          message.percentRegistrationCompleteGrowth = reader.double();
          continue;
        }
        case 37: {
          if (tag !== 297) {
            break;
          }

          message.previousPercentFailedCases = reader.double();
          continue;
        }
        case 38: {
          if (tag !== 305) {
            break;
          }

          message.percentFailedCasesGrowth = reader.double();
          continue;
        }
        case 39: {
          if (tag !== 313) {
            break;
          }

          message.previousAvgProcessingTimeSeconds = reader.double();
          continue;
        }
        case 40: {
          if (tag !== 321) {
            break;
          }

          message.avgProcessingTimeSecondsGrowth = reader.double();
          continue;
        }
        case 41: {
          if (tag !== 329) {
            break;
          }

          message.previousAvgSurveyScore = reader.double();
          continue;
        }
        case 42: {
          if (tag !== 337) {
            break;
          }

          message.avgSurveyScoreGrowth = reader.double();
          continue;
        }
        case 43: {
          if (tag !== 345) {
            break;
          }

          message.previousAvgCasesPerProvider = reader.double();
          continue;
        }
        case 44: {
          if (tag !== 353) {
            break;
          }

          message.avgCasesPerProviderGrowth = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDashboardMetricsResponse {
    return {
      totalSubmittedCases: isSet(object.totalSubmittedCases) ? globalThis.Number(object.totalSubmittedCases) : 0,
      uniqueProvidersSubmitted: isSet(object.uniqueProvidersSubmitted)
        ? globalThis.Number(object.uniqueProvidersSubmitted)
        : 0,
      avgCasesPerProvider: isSet(object.avgCasesPerProvider) ? globalThis.Number(object.avgCasesPerProvider) : 0,
      percentFailedCases: isSet(object.percentFailedCases) ? globalThis.Number(object.percentFailedCases) : 0,
      avgProcessingTimeSeconds: isSet(object.avgProcessingTimeSeconds)
        ? globalThis.Number(object.avgProcessingTimeSeconds)
        : 0,
      percentCasesWithSurvey: isSet(object.percentCasesWithSurvey)
        ? globalThis.Number(object.percentCasesWithSurvey)
        : 0,
      avgSurveyResponse: isSet(object.avgSurveyResponse) ? globalThis.Number(object.avgSurveyResponse) : 0,
      percentSurveysWithComment: isSet(object.percentSurveysWithComment)
        ? globalThis.Number(object.percentSurveysWithComment)
        : 0,
      casesPerDay: globalThis.Array.isArray(object?.casesPerDay)
        ? object.casesPerDay.map((e: any) => DailyMetric.fromJSON(e))
        : [],
      providerSignupsPerDay: globalThis.Array.isArray(object?.providerSignupsPerDay)
        ? object.providerSignupsPerDay.map((e: any) => DailyMetric.fromJSON(e))
        : [],
      totalNewSignups: isSet(object.totalNewSignups) ? globalThis.Number(object.totalNewSignups) : 0,
      percentRegistrationComplete: isSet(object.percentRegistrationComplete)
        ? globalThis.Number(object.percentRegistrationComplete)
        : 0,
      adjudicationSuccessRate: isSet(object.adjudicationSuccessRate)
        ? globalThis.Number(object.adjudicationSuccessRate)
        : 0,
      cancerTypeDistribution: globalThis.Array.isArray(object?.cancerTypeDistribution)
        ? object.cancerTypeDistribution.map((e: any) => DistributionItem.fromJSON(e))
        : [],
      referralTypeDistribution: globalThis.Array.isArray(object?.referralTypeDistribution)
        ? object.referralTypeDistribution.map((e: any) => DistributionItem.fromJSON(e))
        : [],
      modelAdjudicationDistribution: globalThis.Array.isArray(object?.modelAdjudicationDistribution)
        ? object.modelAdjudicationDistribution.map((e: any) => DistributionItem.fromJSON(e))
        : [],
      openaiApiCost: isSet(object.openaiApiCost) ? globalThis.Number(object.openaiApiCost) : 0,
      gcpCost: isSet(object.gcpCost) ? globalThis.Number(object.gcpCost) : 0,
      caseLocations: globalThis.Array.isArray(object?.caseLocations)
        ? object.caseLocations.map((e: any) => LocationData.fromJSON(e))
        : [],
      apiCostsPerDay: globalThis.Array.isArray(object?.apiCostsPerDay)
        ? object.apiCostsPerDay.map((e: any) => DailyCost.fromJSON(e))
        : [],
      previousTotalSubmittedCases: isSet(object.previousTotalSubmittedCases)
        ? globalThis.Number(object.previousTotalSubmittedCases)
        : 0,
      totalSubmittedCasesGrowth: isSet(object.totalSubmittedCasesGrowth)
        ? globalThis.Number(object.totalSubmittedCasesGrowth)
        : 0,
      previousUniqueProvidersSubmitted: isSet(object.previousUniqueProvidersSubmitted)
        ? globalThis.Number(object.previousUniqueProvidersSubmitted)
        : 0,
      uniqueProvidersSubmittedGrowth: isSet(object.uniqueProvidersSubmittedGrowth)
        ? globalThis.Number(object.uniqueProvidersSubmittedGrowth)
        : 0,
      previousTotalNewSignups: isSet(object.previousTotalNewSignups)
        ? globalThis.Number(object.previousTotalNewSignups)
        : 0,
      totalNewSignupsGrowth: isSet(object.totalNewSignupsGrowth) ? globalThis.Number(object.totalNewSignupsGrowth) : 0,
      registrationsCompletedNumerator: isSet(object.registrationsCompletedNumerator)
        ? globalThis.Number(object.registrationsCompletedNumerator)
        : 0,
      registrationsCompletedDenominator: isSet(object.registrationsCompletedDenominator)
        ? globalThis.Number(object.registrationsCompletedDenominator)
        : 0,
      failedCasesNumerator: isSet(object.failedCasesNumerator) ? globalThis.Number(object.failedCasesNumerator) : 0,
      failedCasesDenominator: isSet(object.failedCasesDenominator)
        ? globalThis.Number(object.failedCasesDenominator)
        : 0,
      surveysCompletedNumerator: isSet(object.surveysCompletedNumerator)
        ? globalThis.Number(object.surveysCompletedNumerator)
        : 0,
      surveysCompletedDenominator: isSet(object.surveysCompletedDenominator)
        ? globalThis.Number(object.surveysCompletedDenominator)
        : 0,
      surveysWithCommentsNumerator: isSet(object.surveysWithCommentsNumerator)
        ? globalThis.Number(object.surveysWithCommentsNumerator)
        : 0,
      surveysWithCommentsDenominator: isSet(object.surveysWithCommentsDenominator)
        ? globalThis.Number(object.surveysWithCommentsDenominator)
        : 0,
      previousPercentRegistrationComplete: isSet(object.previousPercentRegistrationComplete)
        ? globalThis.Number(object.previousPercentRegistrationComplete)
        : 0,
      percentRegistrationCompleteGrowth: isSet(object.percentRegistrationCompleteGrowth)
        ? globalThis.Number(object.percentRegistrationCompleteGrowth)
        : 0,
      previousPercentFailedCases: isSet(object.previousPercentFailedCases)
        ? globalThis.Number(object.previousPercentFailedCases)
        : 0,
      percentFailedCasesGrowth: isSet(object.percentFailedCasesGrowth)
        ? globalThis.Number(object.percentFailedCasesGrowth)
        : 0,
      previousAvgProcessingTimeSeconds: isSet(object.previousAvgProcessingTimeSeconds)
        ? globalThis.Number(object.previousAvgProcessingTimeSeconds)
        : 0,
      avgProcessingTimeSecondsGrowth: isSet(object.avgProcessingTimeSecondsGrowth)
        ? globalThis.Number(object.avgProcessingTimeSecondsGrowth)
        : 0,
      previousAvgSurveyScore: isSet(object.previousAvgSurveyScore)
        ? globalThis.Number(object.previousAvgSurveyScore)
        : 0,
      avgSurveyScoreGrowth: isSet(object.avgSurveyScoreGrowth) ? globalThis.Number(object.avgSurveyScoreGrowth) : 0,
      previousAvgCasesPerProvider: isSet(object.previousAvgCasesPerProvider)
        ? globalThis.Number(object.previousAvgCasesPerProvider)
        : 0,
      avgCasesPerProviderGrowth: isSet(object.avgCasesPerProviderGrowth)
        ? globalThis.Number(object.avgCasesPerProviderGrowth)
        : 0,
    };
  },

  toJSON(message: GetDashboardMetricsResponse): unknown {
    const obj: any = {};
    if (message.totalSubmittedCases !== 0) {
      obj.totalSubmittedCases = Math.round(message.totalSubmittedCases);
    }
    if (message.uniqueProvidersSubmitted !== 0) {
      obj.uniqueProvidersSubmitted = Math.round(message.uniqueProvidersSubmitted);
    }
    if (message.avgCasesPerProvider !== 0) {
      obj.avgCasesPerProvider = message.avgCasesPerProvider;
    }
    if (message.percentFailedCases !== 0) {
      obj.percentFailedCases = message.percentFailedCases;
    }
    if (message.avgProcessingTimeSeconds !== 0) {
      obj.avgProcessingTimeSeconds = message.avgProcessingTimeSeconds;
    }
    if (message.percentCasesWithSurvey !== 0) {
      obj.percentCasesWithSurvey = message.percentCasesWithSurvey;
    }
    if (message.avgSurveyResponse !== 0) {
      obj.avgSurveyResponse = message.avgSurveyResponse;
    }
    if (message.percentSurveysWithComment !== 0) {
      obj.percentSurveysWithComment = message.percentSurveysWithComment;
    }
    if (message.casesPerDay?.length) {
      obj.casesPerDay = message.casesPerDay.map((e) => DailyMetric.toJSON(e));
    }
    if (message.providerSignupsPerDay?.length) {
      obj.providerSignupsPerDay = message.providerSignupsPerDay.map((e) => DailyMetric.toJSON(e));
    }
    if (message.totalNewSignups !== 0) {
      obj.totalNewSignups = Math.round(message.totalNewSignups);
    }
    if (message.percentRegistrationComplete !== 0) {
      obj.percentRegistrationComplete = message.percentRegistrationComplete;
    }
    if (message.adjudicationSuccessRate !== 0) {
      obj.adjudicationSuccessRate = message.adjudicationSuccessRate;
    }
    if (message.cancerTypeDistribution?.length) {
      obj.cancerTypeDistribution = message.cancerTypeDistribution.map((e) => DistributionItem.toJSON(e));
    }
    if (message.referralTypeDistribution?.length) {
      obj.referralTypeDistribution = message.referralTypeDistribution.map((e) => DistributionItem.toJSON(e));
    }
    if (message.modelAdjudicationDistribution?.length) {
      obj.modelAdjudicationDistribution = message.modelAdjudicationDistribution.map((e) => DistributionItem.toJSON(e));
    }
    if (message.openaiApiCost !== 0) {
      obj.openaiApiCost = message.openaiApiCost;
    }
    if (message.gcpCost !== 0) {
      obj.gcpCost = message.gcpCost;
    }
    if (message.caseLocations?.length) {
      obj.caseLocations = message.caseLocations.map((e) => LocationData.toJSON(e));
    }
    if (message.apiCostsPerDay?.length) {
      obj.apiCostsPerDay = message.apiCostsPerDay.map((e) => DailyCost.toJSON(e));
    }
    if (message.previousTotalSubmittedCases !== 0) {
      obj.previousTotalSubmittedCases = Math.round(message.previousTotalSubmittedCases);
    }
    if (message.totalSubmittedCasesGrowth !== 0) {
      obj.totalSubmittedCasesGrowth = message.totalSubmittedCasesGrowth;
    }
    if (message.previousUniqueProvidersSubmitted !== 0) {
      obj.previousUniqueProvidersSubmitted = Math.round(message.previousUniqueProvidersSubmitted);
    }
    if (message.uniqueProvidersSubmittedGrowth !== 0) {
      obj.uniqueProvidersSubmittedGrowth = message.uniqueProvidersSubmittedGrowth;
    }
    if (message.previousTotalNewSignups !== 0) {
      obj.previousTotalNewSignups = Math.round(message.previousTotalNewSignups);
    }
    if (message.totalNewSignupsGrowth !== 0) {
      obj.totalNewSignupsGrowth = message.totalNewSignupsGrowth;
    }
    if (message.registrationsCompletedNumerator !== 0) {
      obj.registrationsCompletedNumerator = Math.round(message.registrationsCompletedNumerator);
    }
    if (message.registrationsCompletedDenominator !== 0) {
      obj.registrationsCompletedDenominator = Math.round(message.registrationsCompletedDenominator);
    }
    if (message.failedCasesNumerator !== 0) {
      obj.failedCasesNumerator = Math.round(message.failedCasesNumerator);
    }
    if (message.failedCasesDenominator !== 0) {
      obj.failedCasesDenominator = Math.round(message.failedCasesDenominator);
    }
    if (message.surveysCompletedNumerator !== 0) {
      obj.surveysCompletedNumerator = Math.round(message.surveysCompletedNumerator);
    }
    if (message.surveysCompletedDenominator !== 0) {
      obj.surveysCompletedDenominator = Math.round(message.surveysCompletedDenominator);
    }
    if (message.surveysWithCommentsNumerator !== 0) {
      obj.surveysWithCommentsNumerator = Math.round(message.surveysWithCommentsNumerator);
    }
    if (message.surveysWithCommentsDenominator !== 0) {
      obj.surveysWithCommentsDenominator = Math.round(message.surveysWithCommentsDenominator);
    }
    if (message.previousPercentRegistrationComplete !== 0) {
      obj.previousPercentRegistrationComplete = message.previousPercentRegistrationComplete;
    }
    if (message.percentRegistrationCompleteGrowth !== 0) {
      obj.percentRegistrationCompleteGrowth = message.percentRegistrationCompleteGrowth;
    }
    if (message.previousPercentFailedCases !== 0) {
      obj.previousPercentFailedCases = message.previousPercentFailedCases;
    }
    if (message.percentFailedCasesGrowth !== 0) {
      obj.percentFailedCasesGrowth = message.percentFailedCasesGrowth;
    }
    if (message.previousAvgProcessingTimeSeconds !== 0) {
      obj.previousAvgProcessingTimeSeconds = message.previousAvgProcessingTimeSeconds;
    }
    if (message.avgProcessingTimeSecondsGrowth !== 0) {
      obj.avgProcessingTimeSecondsGrowth = message.avgProcessingTimeSecondsGrowth;
    }
    if (message.previousAvgSurveyScore !== 0) {
      obj.previousAvgSurveyScore = message.previousAvgSurveyScore;
    }
    if (message.avgSurveyScoreGrowth !== 0) {
      obj.avgSurveyScoreGrowth = message.avgSurveyScoreGrowth;
    }
    if (message.previousAvgCasesPerProvider !== 0) {
      obj.previousAvgCasesPerProvider = message.previousAvgCasesPerProvider;
    }
    if (message.avgCasesPerProviderGrowth !== 0) {
      obj.avgCasesPerProviderGrowth = message.avgCasesPerProviderGrowth;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDashboardMetricsResponse>, I>>(base?: I): GetDashboardMetricsResponse {
    return GetDashboardMetricsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDashboardMetricsResponse>, I>>(object: I): GetDashboardMetricsResponse {
    const message = createBaseGetDashboardMetricsResponse();
    message.totalSubmittedCases = object.totalSubmittedCases ?? 0;
    message.uniqueProvidersSubmitted = object.uniqueProvidersSubmitted ?? 0;
    message.avgCasesPerProvider = object.avgCasesPerProvider ?? 0;
    message.percentFailedCases = object.percentFailedCases ?? 0;
    message.avgProcessingTimeSeconds = object.avgProcessingTimeSeconds ?? 0;
    message.percentCasesWithSurvey = object.percentCasesWithSurvey ?? 0;
    message.avgSurveyResponse = object.avgSurveyResponse ?? 0;
    message.percentSurveysWithComment = object.percentSurveysWithComment ?? 0;
    message.casesPerDay = object.casesPerDay?.map((e) => DailyMetric.fromPartial(e)) || [];
    message.providerSignupsPerDay = object.providerSignupsPerDay?.map((e) => DailyMetric.fromPartial(e)) || [];
    message.totalNewSignups = object.totalNewSignups ?? 0;
    message.percentRegistrationComplete = object.percentRegistrationComplete ?? 0;
    message.adjudicationSuccessRate = object.adjudicationSuccessRate ?? 0;
    message.cancerTypeDistribution = object.cancerTypeDistribution?.map((e) => DistributionItem.fromPartial(e)) || [];
    message.referralTypeDistribution = object.referralTypeDistribution?.map((e) => DistributionItem.fromPartial(e)) ||
      [];
    message.modelAdjudicationDistribution =
      object.modelAdjudicationDistribution?.map((e) => DistributionItem.fromPartial(e)) || [];
    message.openaiApiCost = object.openaiApiCost ?? 0;
    message.gcpCost = object.gcpCost ?? 0;
    message.caseLocations = object.caseLocations?.map((e) => LocationData.fromPartial(e)) || [];
    message.apiCostsPerDay = object.apiCostsPerDay?.map((e) => DailyCost.fromPartial(e)) || [];
    message.previousTotalSubmittedCases = object.previousTotalSubmittedCases ?? 0;
    message.totalSubmittedCasesGrowth = object.totalSubmittedCasesGrowth ?? 0;
    message.previousUniqueProvidersSubmitted = object.previousUniqueProvidersSubmitted ?? 0;
    message.uniqueProvidersSubmittedGrowth = object.uniqueProvidersSubmittedGrowth ?? 0;
    message.previousTotalNewSignups = object.previousTotalNewSignups ?? 0;
    message.totalNewSignupsGrowth = object.totalNewSignupsGrowth ?? 0;
    message.registrationsCompletedNumerator = object.registrationsCompletedNumerator ?? 0;
    message.registrationsCompletedDenominator = object.registrationsCompletedDenominator ?? 0;
    message.failedCasesNumerator = object.failedCasesNumerator ?? 0;
    message.failedCasesDenominator = object.failedCasesDenominator ?? 0;
    message.surveysCompletedNumerator = object.surveysCompletedNumerator ?? 0;
    message.surveysCompletedDenominator = object.surveysCompletedDenominator ?? 0;
    message.surveysWithCommentsNumerator = object.surveysWithCommentsNumerator ?? 0;
    message.surveysWithCommentsDenominator = object.surveysWithCommentsDenominator ?? 0;
    message.previousPercentRegistrationComplete = object.previousPercentRegistrationComplete ?? 0;
    message.percentRegistrationCompleteGrowth = object.percentRegistrationCompleteGrowth ?? 0;
    message.previousPercentFailedCases = object.previousPercentFailedCases ?? 0;
    message.percentFailedCasesGrowth = object.percentFailedCasesGrowth ?? 0;
    message.previousAvgProcessingTimeSeconds = object.previousAvgProcessingTimeSeconds ?? 0;
    message.avgProcessingTimeSecondsGrowth = object.avgProcessingTimeSecondsGrowth ?? 0;
    message.previousAvgSurveyScore = object.previousAvgSurveyScore ?? 0;
    message.avgSurveyScoreGrowth = object.avgSurveyScoreGrowth ?? 0;
    message.previousAvgCasesPerProvider = object.previousAvgCasesPerProvider ?? 0;
    message.avgCasesPerProviderGrowth = object.avgCasesPerProviderGrowth ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
